<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Localisation de la ville</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <iframe
            width="100%"
            height="450"
            style="border:0"
            loading="lazy"
            allowfullscreen
            referrerpolicy="no-referrer-when-downgrade"
            [src]="url | safe">
        </iframe>
    </div>
</div>
